import { PulseBaseProvider } from '../../base-classes';

const _storiesCacheKey = 'stories';

export class StoriesProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_storiesCacheKey] = this.storiesSyncer.bind(this);
    }

    async storiesSyncer(params) {
        const { syncParams, resolve, reject, id } = params;
        let queryParams = {
            ...syncParams.stdParameters
            , verbose: syncParams.verbose
            , includeVideos: syncParams.includeVideos
            , recordsLimit: syncParams.recordsLimit
            , category: syncParams.category
        };
        return await super.syncData(syncParams.key, id, queryParams, syncParams.path, resolve, reject, null, syncParams.pulseApi);
    }

    async getStories(stdParameters, path, verbose, category, includeVideos, recordsLimit ) {
        const syncParams = {
            verbose: !!verbose
            , path
            , category
            , includeVideos: !!includeVideos
            , recordsLimit
        };
        const id = JSON.stringify(syncParams);

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        return await super.loadFromStorage(_storiesCacheKey, id, syncParams);
    }
}
